{
  "cp.components.appDrawer.drawerCourses": "Kurse",
  "cp.components.appDrawer.drawerExport": "Export",
  "cp.components.appDrawer.drawerImprint": "Impressum",
  "cp.components.appDrawer.drawerInstitutes": "Institut",
  "cp.components.appDrawer.drawerSettings": "Einstellungen",
  "cp.components.appDrawer.drawerShares": "Freigaben",
  "cp.components.appDrawer.drawerSingleTrainings": "Trainings",
  "cp.components.appDrawer.drawerTrainees": "Teilnehmende",
  "cp.components.appDrawer.drawerTrainers": "Trainer",
  "cp.components.changePassword.changePasswordButton": "Passwort ändern",
  "cp.components.changePassword.currentPassword": "Derzeitiges Passwort",
  "cp.components.changePassword.equalError": "Das neue und alte Passwort sind identisch",
  "cp.components.changePassword.matchError": "Die Passwörter stimmen nicht überein",
  "cp.components.changePassword.newPassword": "Neues Passwort",
  "cp.components.changePassword.newPasswordRepeat": "Neues Passwort wiederholen",
  "cp.components.changePassword.newRequiredError": "Ein neues Password ist notwendig",
  "cp.components.changePassword.newToShortError": "Das eingegebene Passwort ist zu kurz.",
  "cp.components.changePassword.requiredError": "Das derzeitige Passwort ist notwendig",
  "cp.components.changePassword.setPasswordButton": "Passwort ändern",
  "cp.components.changeUserRole.errorSnackbar": "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, falls der Fehler weiterhin besteht.",
  "cp.components.changeUserRole.selectLabel": "Rolle wählen",
  "cp.components.changeUserRole.successSnackbar": "Rolle zu {role} geändert",
  "cp.components.courseTable.deleteLabel": "löschen",
  "cp.components.courseTable.downloadCSVTitle": "Download CSV-Datei",
  "cp.components.courseTable.downloadMessage": "Zum Download ausgewählter Kurs",
  "cp.components.courseTable.selected": "ausgewählt",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Zugehörige Trainer",
  "cp.components.courseTable.tableRowDate": "Datum",
  "cp.components.courseTable.tableRowIdentifier": "Kurs-ID",
  "cp.components.courseTable.tableRowLocation": "Ort",
  "cp.components.courseTable.tableRowProvider": "Anbieter",
  "cp.components.courseTable.tableRowTraineeCount": "Anzahl Teilnehmende",
  "cp.components.courseTable.tableRowValue": "Wert",
  "cp.components.dialog.confirmDeletion.contentConclusion": "Die Löschung ist dauerhaft. Dieses Konto wird nicht mehr verfügbar sein.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Du bist dabei, ein Konto mit den folgenden Rollen zu löschen:",
  "cp.components.dialog.confirmDeletion.title": "Ausgewähltes Konto löschen?",
  "cp.components.footer.rightsReserved": "Alle Rechte vorbehalten.",
  "cp.components.general.institutePageSnackbarError": "Fehler beim Speichern des Instituts",
  "cp.components.general.institutePageSnackbarSuccess": "erfolgreich gespeichert",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "Die E-Mail wurde innerhalb der letzten 10 Minuten versandt. Bitte warte, bevor du eine weitere senden kannst.",
  "cp.components.general.tableRowName": "Name",
  "cp.components.genericTable.emptyMessage": "Leer",
  "cp.components.genericTable.multiSelect": "Alle auswählen",
  "cp.components.genericTable.nextPage": "nächste Seite",
  "cp.components.genericTable.previousPage": "vorhergehende Seite",
  "cp.components.genericTable.rowsPerPageLabel": "Zeilen pro Seite:",
  "cp.components.genericTable.searchPlaceholder": "Suche",
  "cp.components.imprint.pageTitle": "Impressum",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Admin einladen",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Nutzende, welche das Institut verwalten dürfen.",
  "cp.components.instituteAdminTable.adminsTableTitle": "Admins",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Willst du den gewählten Admin wirklich löschen? Diese Änderung ist endgültig.",
  "cp.components.instituteAdminTable.deleteLabel": "löschen",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Willst du den gewählten Trainer wirklich löschen? Diese Änderung ist endgültig.",
  "cp.components.instituteAdminTable.name": "Name",
  "cp.components.instituteAdminTable.selected": "ausgewählt",
  "cp.components.instituteForm.institute": "Institut",
  "cp.components.instituteForm.instituteAddress": "Adresse des Instituts",
  "cp.components.instituteForm.instituteCity": "Stadt",
  "cp.components.instituteForm.instituteCountry": "Land",
  "cp.components.instituteForm.instituteName": "Name des Instituts",
  "cp.components.instituteForm.instituteSaveButton": "Speichern",
  "cp.components.instituteForm.instituteState": "Bundesland",
  "cp.components.instituteForm.instituteStreet": "Straße und Hausnummer",
  "cp.components.instituteForm.instituteStreetAdditional": "Zusätzliche Adressinformationen",
  "cp.components.instituteForm.instituteZIP": "Postleitzahl",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "English",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Français",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Sprache",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Ergebniss-Feedback konfigurieren",
  "cp.components.instituteResultConfig.info": "Diese Änderungen wirken sich auf das gesamte Institut aus. Dafür müssen sich die Trainer erneut in der App einloggen.",
  "cp.components.instituteResultConfig.save": "Konfiguration speichern",
  "cp.components.instituteResultConfig.thresholdGood": "Schwelle \"Gut\"",
  "cp.components.instituteResultConfig.thresholdGreat": "Schwelle \"Hervorragend\"",
  "cp.components.instituteTrainerTable.button": "Trainer einladen",
  "cp.components.instituteTrainerTable.deleteLabel": "löschen",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "ausgewählt",
  "cp.components.instituteTrainerTable.subtitle": "Alle Trainer des Instituts",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Straße",
  "cp.components.instituteTrainerTable.title": "Trainer",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Noch keine Trainer vorhanden",
  "cp.components.invite.inviteCancelButton": "Abbrechen",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Gesendet",
  "cp.components.invite.inviteEmailSent": "Die E-Mail wurde gesendet.",
  "cp.components.invite.inviteFirstnameLabel": "Vorname",
  "cp.components.invite.inviteInvalidEmail": "Diese E-Mail-Adresse ist ungültig.",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Einladung senden",
  "cp.components.invite.inviteSubheader": "Eine Einladung wird an die angegebene E-Mail-Adresse gesendet.",
  "cp.components.invite.inviteSurnameLabel": "Nachname",
  "cp.components.navBar.menuLabel": "Menü",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Passwort ändern",
  "cp.components.passwordForgotSetPassword.matchError": "Das neue Passwort stimmt nicht überein",
  "cp.components.passwordForgotSetPassword.newPassword": "Neues Passwort",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Neues Passwort wiederholen",
  "cp.components.passwordForgotSetPassword.newRequiredError": "Ein neues Password ist notwendig",
  "cp.components.passwordForgotSetPassword.newToShortError": "Das eingegebene Passwort ist zu kurz.",
  "cp.components.reminder.app.appAppStoreButton": "Gehe zum Apple App Store",
  "cp.components.reminder.app.appPlayStoreButton": "Gehe zum Google Play Store",
  "cp.components.reminder.app.content": "Um deinen CorPatch® nutzen zu können, benötigst du die CorPatch® App. Du kannst sie aus dem Google Playstore oder App Store herunter. \n",
  "cp.components.reminder.app.title": "Direkt loslegen? Jetzt die App downloaden!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Willkommen",
  "cp.components.resetPassword.changePasswordButton": "Passwort ändern",
  "cp.components.resetPassword.currentPassword": "Derzeitiges Passwort",
  "cp.components.resetPassword.equalError": "Das neue und alte Passwort sind identisch",
  "cp.components.resetPassword.matchError": "Das neue Passwort stimmt nicht überein",
  "cp.components.resetPassword.newPassword": "Neues Passwort",
  "cp.components.resetPassword.newPasswordRepeat": "Neues Passwort wiederholen",
  "cp.components.resetPassword.newRequiredError": "Ein neues Password ist notwendig",
  "cp.components.resetPassword.requiredError": "Das derzeitige Passwort ist notwendig",
  "cp.components.resetPassword.setPasswordButton": "Passwort ändern",
  "cp.components.singleTrainingsTable.shareDialogContent": "Wähle das Institut aus, mit dem Du dieses Training teilen möchtest:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Training teilen",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Training teilen",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Abbrechen",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Freigabe",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Geteilt am: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Datum",
  "cp.components.singleTrainingsTable.tableRowDepth": "Tiefe",
  "cp.components.singleTrainingsTable.tableRowFlow": "Flow",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Frequenz",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Training",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Entlastung",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Training teilen",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Ausloggen",
  "cp.components.userMenu.password": "Passwort",
  "cp.pages.acceptInvitation.button": "Zur Login-Seite",
  "cp.pages.acceptInvitation.message": "Alles eingestellt. Es kann los gehen.",
  "cp.pages.acceptInvitation.pageNotFound.message": "Die Einladung ist nicht mehr gültig",
  "cp.pages.acceptInvitation.pageNotFound.title": "Einladung nicht gefunden",
  "cp.pages.acceptInvitation.title": "Fertig.",
  "cp.pages.acceptInvitation.welcome": "Herzlich Willkommen",
  "cp.pages.adminInvite.errorSnackbar": "E-Mail {email} ist schon in Benutzung",
  "cp.pages.adminInvite.inviteCardTitle": "Admin einladen",
  "cp.pages.adminInvite.successSnackbar": "E-Mail wurde an {email} gesendet",
  "cp.pages.admins.adminsEmpty.button": "Admin einladen",
  "cp.pages.admins.adminsEmpty.message": "Möchtest du den ersten Instituts-Admin hinzufügen?",
  "cp.pages.admins.adminsEmpty.selected": "ausgewählt",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "E-Mail",
  "cp.pages.admins.adminsEmpty.tableRowName": "Name",
  "cp.pages.admins.adminsEmpty.title": "Noch keine Admins vorhanden!",
  "cp.pages.admins.adminsNotFound.message": "Dieses Institut wurde gelöscht. ",
  "cp.pages.admins.adminsNotFound.title": "Es konnten keine Admins gefunden werden!",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Institut",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Datum",
  "cp.pages.course.cellDuration": "Dauer",
  "cp.pages.course.cellFeedback": "Feedback",
  "cp.pages.course.cellName": "Name",
  "cp.pages.course.rowDepth": "Tiefe",
  "cp.pages.course.rowFlow": "Flow",
  "cp.pages.course.rowFrequency": "Frequenz",
  "cp.pages.course.rowRecoil": "Entlastung",
  "cp.pages.course.title": "Kurs",
  "cp.pages.course.trainees": "Trainees",
  "cp.pages.courses.errorSnackbar": "Der Kurs konnte nicht gelöscht werden.",
  "cp.pages.courses.pageNotFoundMessage": "Wurde gelöscht. Entschuldigung :(",
  "cp.pages.courses.pageNotFoundTitle": "nicht gefunden",
  "cp.pages.courses.pageTitle": "Kurse",
  "cp.pages.courses.roleInstituteAdmin": "Instituts-Admin",
  "cp.pages.courses.roleTrainee": "Teilnehmende",
  "cp.pages.courses.successSnackbar": "Der Kurs wurde erfolgreich gelöscht.",
  "cp.pages.dashboard.cpsCount": "aktive CorPatch® devices",
  "cp.pages.dashboard.cpsCountRecently": "neu verbundenes CorPatch®",
  "cp.pages.dashboard.lastMonth": "Fortschritt im letzten Monat.",
  "cp.pages.dashboard.mobilesCount": "Mobilgeräte erkannt",
  "cp.pages.dashboard.mobilesCountRecently": "neue Mobilgeräte",
  "cp.pages.dashboard.pageTitle": "Statistik",
  "cp.pages.dashboard.trainingsCount": "Trainings insgesamt absolviert",
  "cp.pages.dashboard.usersCount": "registrierte Nutzende insgesamt",
  "cp.pages.dashboard.usersCountRecently": "neu registrierte Nutzende",
  "cp.pages.email.validation.button": "Zum Login",
  "cp.pages.email.validation.text": "Vielen Dank für die Verifizierung der E-Mail Adresse. Dadurch können wir deinen Account weiter absichern und dich auf dem Laufenden halten, falls du das wünschst.",
  "cp.pages.export.pageTitle": "Kurs exportieren",
  "cp.pages.homepage.title": "Startseite",
  "cp.pages.institute.PageNotFound.message": "Dieses Institut wurde gelöscht und kann nicht mehr editiert werden.",
  "cp.pages.institute.PageNotFound.title": "Institut konnte nicht gefunden werden.",
  "cp.pages.institute.institute": "Institut",
  "cp.pages.institute.snackbarError": "Institut konnte nicht gespeichert werden",
  "cp.pages.institute.snackbarSuccess": "Gespeichert",
  "cp.pages.institute.tabsAdmins": "Admins",
  "cp.pages.institute.tabsBaseData": "Basisdaten",
  "cp.pages.institute.tabsTrainers": "Trainer",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Ende: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "Du hast keine aktiven Sharing-Objekte.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "Keine gelöschten Sharing-Objekte.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "Die Freigaben, nach denen Du suchst, existieren nicht.",
  "cp.pages.instituteAdminShares.pageTitle": "Freigaben",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Nicht gefunden",
  "cp.pages.instituteAdminShares.startDate": "Start: ",
  "cp.pages.institutes.addInstituteButton": "Institut hinzufügen",
  "cp.pages.institutes.deleteLabel": "löschen",
  "cp.pages.institutes.errorSnackbar": "Institut konnte nicht gelöscht werden",
  "cp.pages.institutes.pageNotFound.message": "Möchtest du das erste Institut hinzufügen?",
  "cp.pages.institutes.pageNotFound.title": "Es konnte kein Institut gefunden werden.",
  "cp.pages.institutes.pageTitle": "Institut",
  "cp.pages.institutes.successSnackbar": "Institut wurde erfolgreich gelöscht",
  "cp.pages.institutesTable.deleteWarning": "Möchtest du das ausgewählte Institut wirklich löschen? Alle assoziierten Daten und Nutzende werden gelöscht!",
  "cp.pages.institutesTable.instituteLowercase": "Institut",
  "cp.pages.institutesTable.institutesLowercase": "Institut",
  "cp.pages.institutesTable.tableRowCity": "Stadt",
  "cp.pages.institutesTable.tableRowCountry": "Land",
  "cp.pages.institutesTable.tableRowInstitutes": "Institut",
  "cp.pages.institutesTable.tableRowName": "Name",
  "cp.pages.institutesTable.tableRowStreet": "Straße",
  "cp.pages.institutesTable.tableRowZIP": "PLZ",
  "cp.pages.internalServerError.button": "Nochmal versuchen",
  "cp.pages.internalServerError.message": "Der Server konnte deine Anfrage nicht verarbeiten. Das liegt an uns. Entschuldige! Bitte versuche es später noch einmal.",
  "cp.pages.internalServerError.title": "Bitte versuche es später erneut.",
  "cp.pages.login.email": "E-Mail",
  "cp.pages.login.loginButton": "Anmelden",
  "cp.pages.login.loginInstitutesTitle": "Institute",
  "cp.pages.login.password": "Passwort",
  "cp.pages.login.passwordForgot": "Passwort vergessen?",
  "cp.pages.login.registerButton": "Registrieren",
  "cp.pages.login.termsOfUseButton": "Nutzungsbedingungen",
  "cp.pages.login.userNewlyRegisteredLabel1": "Die Registrierung war erfolgreich.",
  "cp.pages.login.userNewlyRegisteredLabel2": "Bitte verifiziere noch deine E-Mail. Der Login ist bereits möglich.",
  "cp.pages.login.userOrPasswordNotFound": "Nutzende oder Passwort stimmen nicht überein",
  "cp.pages.login.validate.errorContent": "Möglicherweise hast du versucht, dich von einem anderen Browser oder Gerät aus anzumelden, oder du hast deinen Browser in der Zwischenzeit geschlossen. Bitte versuche eine weitere E-Mail für die Anmeldung anzufordern.",
  "cp.pages.login.validate.errorSnackbar": "Beim Login ist ein Fehler aufgetreten. Dein Link ist womöglich abgelaufen.",
  "cp.pages.login.validate.errorTitle": "Wir konnten deine Browsersitzung nicht erkennen",
  "cp.pages.login.validate.successContent": "Bitte warte bis wir deinen Login verifizieren konnten.",
  "cp.pages.login.validate.successTitle": "Du wirst nun eingeloggt.",
  "cp.pages.login.validate.validationButton": "Zurück zum Login",
  "cp.pages.login.validate.validationContent": "Wir haben dir eine E-Mail gesendet um deine Anmeldung zu verifizieren.",
  "cp.pages.login.validate.validationTitle": "Bitte verifiziere deine Anmeldung",
  "cp.pages.logout.loginButton": "LOGIN",
  "cp.pages.logout.message": "Bis zum nächsten mal.",
  "cp.pages.logout.title": "Auf Wiedersehen!",
  "cp.pages.me.deleteOwnButtonConfirm": "Account endgültig löschen",
  "cp.pages.me.deleteOwnButtonRequest": "Account endgültig löschen",
  "cp.pages.me.deleteOwnContent": "Diese Aktion wird dein Account permanent löschen. Bitte gehe sicher, dass alle Daten, die dabei verloren gehen könnten bei Bedarf gespeichert wurden. Diese Aktion ist endgültig und der Account kann nicht wieder hergestellt werden.",
  "cp.pages.me.familyName": "Familienname",
  "cp.pages.me.firstName": "Vorname",
  "cp.pages.me.gender": "Geschlecht",
  "cp.pages.me.genderFemale": "Weiblich",
  "cp.pages.me.genderMale": "Männlich",
  "cp.pages.me.genderOther": "Andere",
  "cp.pages.me.notFoundTitle": "Persönliche Einstellungen",
  "cp.pages.me.save": "Speichern",
  "cp.pages.me.snackBarSaved.error": "Fehler beim Speichern der Einstellungen",
  "cp.pages.me.snackBarSaved.saved": "Gespeichert",
  "cp.pages.me.title": "Persönliche Einstellungen",
  "cp.pages.networkError.pageNotFound.button": "Nochmal versuchen",
  "cp.pages.networkError.pageNotFound.message": "Der Server konnte die Anfrage nicht verarbeiten. Ist deine Internetverbindung stabil? ",
  "cp.pages.networkError.pageNotFound.title": "Der Server scheint ausgefallen zu sein. Das liegt an uns! Bitte versuche es später noch einmal. ",
  "cp.pages.notFound.message": "Die Seite konnte nicht gefunden werden. ",
  "cp.pages.notFound.title": "Nichts gefunden.",
  "cp.pages.passwordForgot.confirmationMessage": "Die E-Mail zur Verifikation wird an deine Adresse gesendet.",
  "cp.pages.passwordForgot.confirmationMessage2": "Bitte überprüfe deine E-Mails.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Wir haben dir einen Aktivierungslink gesendet an",
  "cp.pages.passwordForgot.confirmationSent": "E-Mail senden",
  "cp.pages.passwordForgot.confirmationTitle": "Passwort zurücksetzen",
  "cp.pages.passwordForgot.eMail": "E-Mail",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Zurück zum Login",
  "cp.pages.passwordForgot.passwordForgotTitle": "Passwort vergessen",
  "cp.pages.passwordForgotSetPassword.button": "Zurück zum Login",
  "cp.pages.passwordForgotSetPassword.message": "Alles eingestellt. Es kann los gehen.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Der Code ist nicht mehr gültig",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Nicht mehr gültig.",
  "cp.pages.passwordForgotSetPassword.title": "Passwort wurde geändert.",
  "cp.pages.passwordForgotSetPassword.welcome": "Willkommen!",
  "cp.pages.register.acceptTermsOfUse": "Akzeptierst du unsere Nutzungsbedingungen?",
  "cp.pages.register.create": "Account erstellen",
  "cp.pages.register.emailField": "E-Mail",
  "cp.pages.register.errorSnackbar": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es nochmal.",
  "cp.pages.register.firstnameField": "Vorname",
  "cp.pages.register.lastnameField": "Nachname",
  "cp.pages.register.newToShortError": "Das eingegebene Passwort ist zu kurz.",
  "cp.pages.register.passwordField": "Passwort",
  "cp.pages.register.successSnackbar": "Die Registrierung war erfolgreich",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Balken",
  "cp.pages.settings.feedbackMode.menuItemNone": "Kein Feedback",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pumpe",
  "cp.pages.settings.menuItemThresholdGood": "Schwelle Feedback \"Gut\"",
  "cp.pages.settings.menuItemThresholdGreat": "Schwelle Feedback \"Hervorragend\"",
  "cp.pages.settings.resultType.menuItemExpert": "Erfahrene",
  "cp.pages.settings.resultType.menuItemNone": "Kein Feedback",
  "cp.pages.settings.resultType.menuItemSimple": "Einfach",
  "cp.pages.settings.resultType.menuItemStandard": "Standard",
  "cp.pages.settings.tableRowCompression": "Nur Herzdruckmassage",
  "cp.pages.settings.tableRowDuration": "Sitzungsdauer",
  "cp.pages.settings.tableRowERC": "Auf Lebenszeichen überprüfen",
  "cp.pages.settings.tableRowFeedback": "Feedback-Modus",
  "cp.pages.settings.tableRowFrequency": "Ziel-Frequenz",
  "cp.pages.settings.tableRowLocked": "Festgestellt",
  "cp.pages.settings.tableRowProperty": "Eigenschaft",
  "cp.pages.settings.tableRowResult": "Ergebnisdarstellung",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Ergebnis-Feedback speichern",
  "cp.pages.settings.tableRowSaveButton": "Speichern",
  "cp.pages.settings.tableRowTrainees": "Standard-Anzahl von Teilnehmern",
  "cp.pages.settings.tableRowType": "Trainingsart",
  "cp.pages.settings.tableRowValue": "Wert",
  "cp.pages.settings.title": "Einstellungen für CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "API Zugriff",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Möchtest Du das Sharing-Objekt wirklich löschen?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Diese Aktion kann nicht rückgängig gemacht werden, es gehen jedoch keine Daten verloren. Das gemeinsam genutzte Objekt wird als deaktiviert angezeigt.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Abbrechen",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Geteiltes Objekt entfernen",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Löschen",
  "cp.pages.sharingObject.form.deleteButton": "Löschen",
  "cp.pages.sharingObject.form.disabled": "Deaktiviert",
  "cp.pages.sharingObject.form.enabled": "Aktiviert",
  "cp.pages.sharingObject.form.invitationCode": "Code der Einladung",
  "cp.pages.sharingObject.form.invitationLink": "Einladungs-Link",
  "cp.pages.sharingObject.form.name": "Name",
  "cp.pages.sharingObject.form.pullApiSecret": "Geheimnis",
  "cp.pages.sharingObject.form.pullUrl": "URL abrufen",
  "cp.pages.sharingObject.form.saveButton": "Speichern",
  "cp.pages.sharingObject.form.title": "Geteiltes Objekt",
  "cp.pages.sharingObject.form.webHook": "Webhook",
  "cp.pages.sharingObject.pageNotFoundDescription": "Die geteilten Objekte, nach denen Du suchst, existieren nicht.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Nicht gefunden",
  "cp.pages.sharingObject.pageTitle": "Freigaben",
  "cp.pages.sharingObject.snackBarDeleteError": "Konnte nicht gelöscht werden",
  "cp.pages.sharingObject.snackBarDeleted": "Gelöscht",
  "cp.pages.sharingObject.snackBarSaveError": "Konnte nicht speichern",
  "cp.pages.sharingObject.snackBarSaved": "Gespeichert",
  "cp.pages.singleTraining.multipleTrainings": "Trainings",
  "cp.pages.singleTraining.singleTraining": "Training",
  "cp.pages.singleTraining.table.created": "Erstellt",
  "cp.pages.singleTraining.table.name": "Ganzer Name",
  "cp.pages.singleTraining.table.selected": "ausgewählt",
  "cp.pages.singleTraining.title": "Deine Trainings",
  "cp.pages.trainee.cpsButton": "CorPatch®-Daten Download",
  "cp.pages.trainee.delete.errorSnackbar": "Ein unbekannter Fehler ist aufgetreten",
  "cp.pages.trainee.delete.successSnackbar": "Trainees wurden erfolgreich gelöscht",
  "cp.pages.trainee.delete.warningSnackbar": "Ein oder mehrere Benutzenden wurden nicht gelöscht",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Löschen",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Schließen",
  "cp.pages.trainee.deleteLabel": "löschen",
  "cp.pages.trainee.mobileButton": "Smartphone-Daten Download",
  "cp.pages.trainee.multipleTrainees": "Teilnehmende",
  "cp.pages.trainee.singleTrainee": "Teilnehmende",
  "cp.pages.trainee.table.created": "Erstellung",
  "cp.pages.trainee.table.email": "E-Mail",
  "cp.pages.trainee.table.name": "Name",
  "cp.pages.trainee.table.selected": "ausgewählt",
  "cp.pages.trainee.title": "Teilnehmende",
  "cp.pages.traineeShares.active": "Aktiv",
  "cp.pages.traineeShares.addDialogAdd": "Hinzufügen",
  "cp.pages.traineeShares.addDialogCancel": "Abbrechen",
  "cp.pages.traineeShares.addDialogDescription": "Gib den Einladungscode ein, den Du von Deiner Partnerorganisation erhalten hast:",
  "cp.pages.traineeShares.addDialogDescription2": "Wenn Du auf „Hinzufügen“ klickst, bestätigst Du, dass Du den Allgemeinen Geschäftsbedingungen und der Datenschutzrichtlinie zustimmst, die Dir von der Partnerorganisation zusammen mit diesem Einladungslink/Code zur Verfügung gestellt wurden. Es ist wichtig, diese Bedingungen zu lesen und zu verstehen, bevor Du fortfährst.",
  "cp.pages.traineeShares.addDialogTitle": "Einladung",
  "cp.pages.traineeShares.addShare": "Freigabe hinzufügen",
  "cp.pages.traineeShares.deactivateDialogDescription": "Möchtest Du diese Teilnahmevereinbarung mit {instituteName} wirklich deaktivieren?",
  "cp.pages.traineeShares.deactivateDialogNo": "Abbrechen",
  "cp.pages.traineeShares.deactivateDialogTitle": "Deaktivieren",
  "cp.pages.traineeShares.deactivateDialogYes": "Deaktivieren",
  "cp.pages.traineeShares.deactivateTooltip": "Deaktivieren",
  "cp.pages.traineeShares.endDate": "Enddatum: ",
  "cp.pages.traineeShares.inactive": "Inaktiv",
  "cp.pages.traineeShares.noActiveItemsMessage": "Derzeit hast Du keinen Datenaustauschvereinbarungen zugestimmt. Drücke auf die Plus-Taste unten rechts, um einen entsprechenden Einladungscode einzugeben.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Keine inaktiven Freigaben.",
  "cp.pages.traineeShares.pageNotFoundMessage": "Die von Ihnen gesuchten Training-Freigaben existieren nicht.",
  "cp.pages.traineeShares.pageTitle": "Teilnehmende Freigaben",
  "cp.pages.traineeShares.pageTitleNotFound": "Nicht gefunden",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Fehler beim Hinzufügen der Einladung: {errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Fehler beim Deaktivieren der Freigabe: {errorMessage}!",
  "cp.pages.traineeShares.snackBarInvalidCode": "Bitte gib einen gültigen Einladungscode ein.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Einladung hinzugefügt",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Freigabe deaktiviert",
  "cp.pages.traineeShares.startDate": "Startdatum: ",
  "cp.pages.trainerInvite.errorSnackbar": "E-Mail ist schon in Benutzung",
  "cp.pages.trainerInvite.successSnackbar": "E-Mail wird gesendet an {email}",
  "cp.pages.trainerInvite.title": "Trainer einladen",
  "cp.pages.trainers.errorSnackbar": "Der Benutzende konnte nicht gelöscht werden. Bitte versuche es erneut!",
  "cp.pages.trainers.successSnackbar": "Gelöscht",
  "cp.pages.trainersNotAvailable.button": "Trainer einladen",
  "cp.pages.trainersNotAvailable.message": "Möchtest du den ersten Trainer einladen?",
  "cp.pages.trainersNotAvailable.title": "Noch keine Trainer vorhanden!",
  "cp.pages.trainersNotFound.message": "Dieser Trainer wurde gelöscht. Entschuldigung :(",
  "cp.pages.trainersNotFound.title": "Trainer nicht gefunden",
  "cp.pages.trainersTable.deleteLabel": "löschen",
  "cp.pages.trainersTable.inviteTrainer": "Trainer einladen",
  "cp.pages.trainersTable.selected": "ausgewählt",
  "cp.pages.trainersTable.tableRowEmail": "E-Mail",
  "cp.pages.trainersTable.tableRowName": "Name",
  "cp.pages.trainersTable.trainers": "Trainer",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Abbrechen",
  "cp.pages.userChangeEmail.changeEmail": "E-Mail ändern",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "E-Mail wurde geändert",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "E-Mail konnte nicht geändert werden",
  "cp.pages.userChangeEmail.newEmail": "Neue E-Mail",
  "cp.pages.userChangeEmail.notFound.message": "Dieser Benutzende existiert nicht mehr.",
  "cp.pages.userChangeEmail.notFound.title": "Nichts gefunden.",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "E-Mail gesendet",
  "cp.pages.userChangeEmail.verifyEmail.button": "Sende mir eine neue Bestätigungs-E-Mail an meine Adresse",
  "cp.pages.userChangeEmail.verifyEmail.content": "Wir möchten dich über die wichtigsten Änderungen unserer App und unseren Produkten auf dem Laufenden halten. Daher müssen wir deine E-Mail-Adresse verifizieren.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Bitte verifiziere deine E-Mail-Adresse",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Passwort konnte nicht geändert werden",
  "cp.pages.userChangePassword.notFound.message": "Dieser Benutzende wurde gelöscht.",
  "cp.pages.userChangePassword.notFound.title": "Nutzende nicht gefunden.",
  "cp.pages.userChangePassword.successSnackbar": "Passwort wurde geändert",
  "cp.pages.userChangePassword.title": "Passwort ändern",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "Das aktuelle Passwort ist falsch",
  "cp.pages.userDetails.errorSnackbar": "Die Einladung konnte leider nicht gesendet werden.",
  "cp.pages.userDetails.invitation": "Einladung",
  "cp.pages.userDetails.notFound.message": "Diese Information wurde gelöscht. ",
  "cp.pages.userDetails.notFound.title": "Nicht gefunden",
  "cp.pages.userDetails.sendInvitation": "Einladung senden",
  "cp.pages.userDetails.signUpAccepted": "Akzeptiert",
  "cp.pages.userDetails.signUpPending": "ausstehend",
  "cp.pages.userDetails.successSnackbar": "Einladung gesendet",
  "cp.pages.userDetails.userDetailsEmail": "E-Mail"
}